import { useContext } from "react";
import { AuthContext } from "context/AuthContext";

// Хук для зручного доступу до контексту авторизації
export const useAuth = () => {
  return useContext(AuthContext);
};
